import {
  getAdjudicationJustificationsReadTasksAdjudicationJustificationsGet,
  AdjudicationJustificationSchema,
  GetAdjudicationJustificationsReadTasksAdjudicationJustificationsGetData,
} from '@common/config/api/client'
import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export function useGetAdjudicationJustifications(
  queryKey: [string],
  queryParams: GetAdjudicationJustificationsReadTasksAdjudicationJustificationsGetData['query'],
) {
  return useQuery<{ data: AdjudicationJustificationSchema[] }, AxiosError>({
    queryKey,
    queryFn: async () => {
      const response = await getAdjudicationJustificationsReadTasksAdjudicationJustificationsGet({
        throwOnError: true,
        query: queryParams,
      })
      return { data: response.data }
    },
  })
}
